const t = {
  styleOverrides: {
    root: ({ theme: o }) => ({
      color: o.palette.text.secondary,
      padding: o.spacing(1, 2, 2)
    })
  }
};
export {
  t as default
};
